import React from 'react';
import { useState } from 'react';
import { simpleGetCall } from '../api/ApiServices';
import ApiConfig from '../api/ApiConfig';
import { useEffect } from 'react';

const TermsDescp = () => {

    const [termsData, setTermsData] = useState([]);

    useEffect(() => {
        FetchAllTerms();
    }, [])

    const FetchAllTerms = () => {
        simpleGetCall(ApiConfig.GET_TERMS_AND_CONDITION)
            .then((data) => {
                setTermsData(data.commonText);
                // setLoading(false);
                console.log("Terms Data", data.commonText);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <div className='logout_aboutUs'>
            <div className='innerCardAbt'>
                <h2 className='headingTxt'>Terms & Conditions Description</h2>
                <label className='InsideTxt'>{termsData}</label>
            </div>
        </div>
    )
}

export default TermsDescp;
